"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.populateBlenderVariablesForState = exports.getBlendMode = void 0;
const blender_1 = require("@clds/blender");
const getBlendMode = (selectionVariant, isSelected, variant) => {
    if (isSelected) {
        return selectionVariant === 'solid' ? 'solidContrast' : 'plainSolid';
    }
    return variant === 'primary' ? 'surfaceContrast' : 'plainSolid';
};
exports.getBlendMode = getBlendMode;
const intensityByState = {
    normal: 'md',
    hover: 'sm',
    selected: 'lg',
    selectedHover: 'xl',
};
const populateBlenderVariablesForState = (state) => ({ variant, selectionVariant, isSelected, }) => {
    const mode = (0, exports.getBlendMode)(selectionVariant, isSelected, variant);
    return blender_1.blenderCss.populateVariables({
        mode,
        variant,
        intensity: intensityByState[state],
    });
};
exports.populateBlenderVariablesForState = populateBlenderVariablesForState;
//# sourceMappingURL=mixins.js.map